import { useEffect, useState } from "react";
import bot from '../images/happy.png';
import you from '../images/boy.png';
import site1 from '../images/Building1.jpg';
import site2 from '../images/Building2.jpg';
import LoadingDots from "./LoadingDots";
import Amenitics from "./Amenitics";
import DownloadBrochure from "./DownloadBrochure";
import RequestACall from "./RequestACall";
import ContactUs from "./ContactUs";
import PropertyType from "./PropertyType";
import ProjectHighlights from "./ProjectHighlights";
import FloorPlan from "./FloorPlan";
import LiveImages from "./LiveImages";

const Residential = () => {
  const [time] = useState(new Date());
  const images = [{ src: site1, alt: "Site 1" }, { src: site2, alt: "Site 2" }];
  const [index, setIndex] = useState(0);
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);
  const [activeFrame, setActiveFrame] = useState(null);
  const [loading, setLoading] = useState(true);
  const siteType = 1;

  useEffect(() => {
    fetch(`https://realestatechatbotapi.onrender.com/projects/category/${siteType}`)
      .then((res) => res.json())
      .then((data) => {
        setSites(data);
        setLoading(false);
      })
      .catch((err) => console.error("Error fetching data:", err));
  }, []);

  // Auto-scroll effect
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  const moveLeft = () => {
    if (index > 0) setIndex(index - 1);
  };

  const moveRight = () => {
    if (index < images.length - 1) setIndex(index + 1);
  };

  const handleShowFrame = (frameNumber) => {
    if (sites.length > 0) {
      setSelectedSite(sites[index]);
      setActiveFrame(frameNumber);
    }
  };

  return (
    <>
      <div className="chatbot">
        <img src={bot} alt="bot" className="bot" />
        <div className="chatbot-time">{time.toLocaleTimeString()}</div>
      </div>

      <div className="frame1 animated-frame">
        <div className="carousel-container">
          <button onClick={moveLeft} className="nav-button left">&#60;</button>

          <div className="image-container">
            {loading ? (
              <LoadingDots />
            ) : sites.length > 0 && sites[index] ? (
              <>
                <b className="project-title">{sites[index].project_name}</b>
                <img
                  src={images[index]?.src}
                  alt={images[index]?.alt}
                  className="carousel-image"
                />
              </>
            ) : (
              <p>No project data found.</p>
            )}
          </div>

          <button onClick={moveRight} className="nav-button right">&#62;</button>
        </div>
      </div>

      {loading ? (
        <div className="frame1"><LoadingDots /></div>
      ) : sites[index] && (
        <div className="frame1 animated-frame">
          <p><strong>Project Name:</strong> {sites[index].project_name}</p>
          <p><strong>Location:</strong> {sites[index].location}</p>
          <p><strong>Description:</strong> {sites[index].description}</p>
        </div>
      )}

      <div className="frame1 animated-frame">
        {loading ? (
          <LoadingDots />
        ) : (
          <>
            <p>Would you like to know more details about the project?</p>
            <div style={{ textAlign: "center" }}>
              <button className="details-button" onClick={() => handleShowFrame(1)}>Amenities</button>
              <button className="details-button" onClick={() => handleShowFrame(2)}>Project Highlights</button>
              <button className="details-button" onClick={() => handleShowFrame(3)}>Live Images</button>
              <button className="details-button" onClick={() => handleShowFrame(4)}>Download Brochure</button>
              <button className="details-button1" onClick={() => handleShowFrame(5)}>Master Plan & Floor Plan</button>
              <button className="details-button" onClick={() => handleShowFrame(6)}>Book A Site Visit</button>
              <button className="details-button" onClick={() => handleShowFrame(7)}>Contact Us</button>
              <button className="details-button" onClick={() => handleShowFrame(8)}>Main menu</button>
              <button className="details-button" onClick={() => handleShowFrame(9)}>Previous Menu</button>
            </div>
          </>
        )}
      </div>

      {activeFrame === 1 && selectedSite && <Amenitics siteId={selectedSite.project_id} />}
      {activeFrame === 2 && selectedSite && <ProjectHighlights siteId={selectedSite.project_id} />}
      {activeFrame === 3 && selectedSite && <LiveImages siteId={selectedSite.project_id} />}
      {activeFrame === 4 && selectedSite && <DownloadBrochure siteId={selectedSite.project_id} />}
      {activeFrame === 5 && selectedSite && <FloorPlan siteId={selectedSite.project_id} />}
      {activeFrame === 6 && selectedSite && <RequestACall siteId={selectedSite.project_id} />}
      {activeFrame === 7 && <ContactUs />}
      {activeFrame === 8 && <PropertyType />}
      {activeFrame === 9 && <PropertyType />}
    </>
  );
};

export default Residential;
